import React, { useState, useEffect } from "react";
import "./style.scss";
import { LoadingOutlined } from "@ant-design/icons";
import { blue } from "@ant-design/colors";
import {
  Layout,
  Table,
  Checkbox,
  Button,
  Space,
  PageHeader,
  Row,
  Col,
  Modal,
  Card,
  Dropdown,
} from "antd";
import MenuService from "../../services/MenuService";
import R2Footer from "../../components/Footer";
import { useHistory } from "react-router";
import modes from "../../components/view-modes";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styles from "./style.module.scss";
import Training from "./training";
import info from "../../assets/images/info.png";
const { Content } = Layout;

const columns = [
  // {
  //     title: 'Action',
  //     key: 'action',
  //     render: () => {
  //         return <div>
  //             <EditOutlined style={{ color: blue[5] }} alt="Edit" /> &nbsp;&nbsp;
  //             <EyeInvisibleOutlined style={{ color: red[5] }} alt="Deactivate" />
  //         </div>
  //     }
  // },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    render: (text) => (
      <b style={{ color: blue[5], cursor: "pointer" }}>{text}</b>
    ),
  },
  {
    title: "Default",
    dataIndex: "is_default",
    key: "is_default",
    render: (c) => <Checkbox checked={c} />,
  },
  {
    title: "Start Time",
    dataIndex: "start_time",
    key: "start_time",
  },
  {
    title: "End Time",
    dataIndex: "end_time",
    key: "end_time",
  },
];

const Menus = (props) => {
  const [loading, setLoading] = useState(true);
  const [menus, setMenus] = useState([]);
  const [mode, setMode] = useState(modes.cards);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();

  const getMenus = async () => {
    const restaurant_id = props.adminRestaurant;

    const data = await MenuService.getMenus(restaurant_id);
    if(props.isCatering)
      setMenus(
        data.menus?.filter(item => item?.type?.toLowerCase() === "catering")
      );
    else
    setMenus(data.menus);
    setLoading(false);
  };

  useEffect(() => {
    getMenus();
  }, [props.adminRestaurant]);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Layout style={{ padding: "0 18px 8px" }}>
      <Content
        className="page-padding"
        style={{
          
          margin: "8px 0px",
          minHeight: 280,
          position: "relative",
        }}
      >
        {loading ? (
          <LoadingOutlined style={{ fontSize: "30px" }} />
        ) : (
          <Space direction="vertical" style={{ width: "100%" }}>
            <PageHeader
              title="Menu"
              className="page-header"
              extra={[
                <Button
                  type="primary"
                  className="btn-round"
                  onClick={() => history.push("/menu/add"+ (props.isCatering ? "?isCatering=true" : ""))}
                >
                  Add New Menu
                </Button>
              ]}
            />
            {mode === "table" ? (
              <Table
                columns={columns}
                dataSource={menus}
                onRow={(menu) => {
                  return {
                    onClick: (event) => {
                      history.push(`/menus/${menu.id}/menu-items/${menu.name}`);
                    },
                  };
                }}
              />
            ) : (
              <Row>
                {menus.map((menu, index) => (
                  <Col
                    className="gutter-row relative menu_cardmain"
                    key={menu.id}
                  >
                    <Card
                      onClick={() => {
                        history.push(`/menus/${menu.id}`);
                      }}
                      style={{ width: 328, cursor: "pointer" }}
                      className={styles.menu_card}
                      cover={
                        <img
                          alt={menu.name}
                          className={styles.menu_img}
                          // style={{ height: 160 }}
                          src={menu.photo_url}
                        />
                      }
                    >
                      <div onClick={(e) => e.stopPropagation()}>
                        <Dropdown
                          style={{ cursor: "pointer" }}
                          menu={{
                            items: [
                              {
                                label: (
                                  <a
                                    onClick={() => {
                                      history.push(`/edit-menu/${menu.id}`+ (props.isCatering ? "?isCatering=true" : ""));
                                    }}
                                  >
                                    Edit Menu
                                  </a>
                                ),
                                key: menu.id,
                              },
                            ],
                          }}
                          trigger={["click"]}
                        >
                          <div className="dot-dropdown">
                            <div className="dropdown">
                              <button type="button" className="dropbtn">
                                ...
                              </button>
                            </div>
                          </div>
                        </Dropdown>
                      </div>

                      <div className={styles.menu_timewrap}>
                        <div>
                          <h2 className={styles.menu_title}>{menu.name}</h2>
                          <div className={styles.menu_time}>
                            {menu.start_time?.substring(0, 5)} -{" "}
                            {menu.end_time?.substring(0, 5)}
                          </div>
                        </div>
                        {/* <Button type="primary" className="btn-round" >Add Sections & Items</Button> */}
                      </div>
                      {/* <Meta
                                                    title={menu.name}
                                                    className={styles.menu_meta}
                                                /> */}
                    </Card>
                  </Col>
                ))}
              </Row>
            )}
            <div
              className={styles.infobtn}
              onClick={() => setIsModalOpen(true)}
            >
              <img src={info} alt="info" />
            </div>
          </Space>
        )}
      </Content>
      <R2Footer />
      <Modal
        className="modal_close"
        title=""
        footer={null}
        visible={isModalOpen}
        width="900px"
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <Training />
      </Modal>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Menus));
